import axios from "axios";

export const API_BASE_URL =
  (typeof process !== "undefined" && process.env && process.env.VITE_API_BASE_URL) ||
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API_BASE_URL) ||
  "https://api.devrishihospital.com/api/v1";

export const BACKEND_URL =
  (typeof process !== "undefined" && process.env && process.env.VITE_BACKEND_URL) ||
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_BACKEND_URL) ||
  "https://api.devrishihospital.com";

const DOCTOR_API = "/doctors";
const SERVICE_API = "/services"
const NEWS_API = "/news"
const APPOINTMENT_API = "/appointments"
const JOB_API = "/jobs"
const APPLICANT_API = "/applicants"
const BLOG_API = "/blogs"
const NOTIFICATION_API = "/notifications"

// doctor api
export const getAllDoctors = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}${DOCTOR_API}`)
        return response?.data
    } catch (err) {
        throw err
    }
}

export const getDoctorByslug = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${DOCTOR_API}/slug/${slug}`)
        return response?.data;
    } catch (err) {
        console.error("Error in getting doctor by slug", err)
        throw err
    }
}

// Service Api
export const getAllServices = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}${SERVICE_API}`)
        return response?.data
    } catch (err) {
        throw err
    }
}

export const getServiceBySlug = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${SERVICE_API}/slug/${slug}`)
        return response?.data
    } catch (err) {
        console.error("Error in getting service detail by slug")
        throw err
    }
}

export const getAllNews = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}${NEWS_API}`)
        return response?.data
    } catch (err) {
        throw err
    }
}

// Appointment Api
export const createAppointment = async (appointmentData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}${APPOINTMENT_API}`, appointmentData)
        return response?.data
    } catch (err) {
        console.error("Error in creating appointment", err)
        throw err
    }
}

// Job openings
export const getAllJobsOpenings = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}${JOB_API}`)
        return response?.data
    } catch (err) {
        console.error("Error in getting all job openings", err)
    }
}

export const getJobId = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${JOB_API}/${id}`)
        return response?.data
    } catch (err) {
        console.error("Error in getting job id", err)
    }
}

export const applyToJob = async (applicantData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}${APPLICANT_API}`, applicantData)
        return response?.data
    } catch (err) {
        console.error("Error during Applied to job", err)
        throw err
    }
}

export const getAllBlogs = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}${BLOG_API}`)
        return response?.data
    } catch (err) {
        throw err
    }
}

export const getBlogSlug = async (slug) => {
    try {
        const response = await axios.get(`${API_BASE_URL}${BLOG_API}/slug/${slug}`)
        return response?.data
    } catch (err) {
        throw err
    }
}

// Get all notifications
// Get all notifications
export const getAllNotifications = async () => {

    const response = await axios.get(
        `${API_BASE_URL}${NOTIFICATION_API}`
    );

    return response.data;

};